module.exports = __webpack_public_path__ + "static/media/23.22675647.mp3";